import(/* webpackMode: "eager", webpackExports: ["NativeRedirect"] */ "/www/wwwroot/gass/fe-new/components/landing/native-redirect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/www/wwwroot/gass/fe-new/node_modules/next/dist/client/app-dir/link.js");
